module.exports = __webpack_public_path__ + "img/car.89257202.png";